import styles from "../../styles/Components/exchange-portfolio/ExchangeBalanceInfo.module.css";
import useExchangePortfolioInfo from "../../hooks/exchange/useExchangePortfolioInfo";
import { Skeleton } from "antd";
import { formatPrice } from "../../utility/helper";
import { GoDotFill } from "react-icons/go";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { FaRegCalendarDays } from "react-icons/fa6";

function ExchangeBalanceInfo({ className = "" }) {
  const { balanceLoading, portfolioLoading, balanceChange, totalBalance } =
    useExchangePortfolioInfo();

  const {
    "7d": { percent: weeklyChangePercentage, usd: weeklyChangeUsd },
    "24h": { percent: dailyChangePercentage, usd: dailyChangeUsd },
  } = balanceChange;

  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.totalBalance}>
        <h5>Total Balance</h5>
        <span className={styles.totalValue}>
          {portfolioLoading ? (
            <Skeleton.Node className={styles.loader} active />
          ) : (
            `$${formatPrice(totalBalance)}`
          )}
        </span>
      </div>
      <div className={styles.balanceChanges}>
        <div className={styles.balanceChangeInfo}>
          <div className={styles.balanceChangeValue}>
            {balanceLoading ? (
              <Skeleton.Node className={styles.balanceLoader} active />
            ) : (
              <>
                <span
                  className={`${weeklyChangeUsd !== 0 ? (weeklyChangeUsd > 0 ? styles.positive : styles.negative) : ""}`}
                >
                  {weeklyChangeUsd?.toFixed(2)}
                </span>
                <GoDotFill className={styles.separator} />
                <span
                  className={`${weeklyChangePercentage !== 0 ? (weeklyChangePercentage > 0 ? styles.positive : styles.negative) : ""}`}
                >
                  {weeklyChangePercentage?.toFixed(2)}%
                </span>
              </>
            )}
          </div>
          <span className={styles.changeLabel}>
            7D <FaRegCalendarDays />
          </span>
        </div>
        <div className={styles.balanceChangeInfo}>
          <div className={styles.balanceChangeValue}>
            {balanceLoading ? (
              <Skeleton.Node className={styles.balanceLoader} active />
            ) : (
              <>
                <span
                  className={`${dailyChangeUsd !== 0 ? (dailyChangeUsd > 0 ? styles.positive : styles.negative) : ""}`}
                >
                  {dailyChangeUsd?.toFixed(2)}
                </span>
                <GoDotFill className={styles.separator} />
                <span
                  className={`${dailyChangePercentage !== 0 ? (dailyChangePercentage > 0 ? styles.positive : styles.negative) : ""}`}
                >
                  {dailyChangePercentage?.toFixed(2)}%
                </span>
              </>
            )}
          </div>
          <span className={styles.changeLabel}>
            24H <MdOutlineAccessTimeFilled />
          </span>
        </div>
      </div>
    </div>
  );
}

export default ExchangeBalanceInfo;
